<template>
    <div v-if="isLoading" class="flex items-center justify-center gap-2 py-10">
        <div class="font-medium">{{ $t('views.farmToFarm.loading') }}</div>
        <Spinner class="w-5 h-5" />
    </div>

    <div v-else-if="isError" class="py-10 text-center">
        <p class="text-sm text-red-600">{{ $t('views.farmToFarm.loadError') }}</p>
        <CustomButton class="mt-4 max-w-32" color-preset="secondary" @click="$emit('retry')">
            {{ $t('views.farmToFarm.retry') }}
        </CustomButton>
    </div>

    <slot v-else></slot>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import CustomButton from '@/components/ui/CustomButton.vue';
import Spinner from '@/components/ui/Spinner.vue';

/**
 * The shared loading and error states for the wizard's two picker steps.
 *
 * Deliberately not hoisted into FarmToFarmSteps.vue: the steps read different queries, so a shell that
 * gated on both would make the farm step wait on the unrelated period request.
 */
export default defineComponent({
    components: { CustomButton, Spinner },
    props: {
        isLoading: {
            type: Boolean,
            required: true,
        },
        isError: {
            type: Boolean,
            required: true,
        },
    },
    // Reports the click rather than taking `refetch`, so each step stays the owner of its own query.
    emits: ['retry'],
});
</script>
